import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';
import DashboardPage from '../pages/DashboardPage';
import UsersPage from '../pages/UsersPage';
import UserDetailPage from '../pages/UserDetailPage';

const DashboardLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900">
      <div className="flex h-screen">
        {/* Sidebar */}
        <div className="fixed left-0 top-0 h-full z-30">
          <Sidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 ml-64 flex flex-col">
          {/* Top Navbar */}
          <TopNavbar />

          {/* Page Content */}
          <main className="flex-1 overflow-y-auto">
            <Routes>
              <Route index element={<DashboardPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="users/:email" element={<UserDetailPage />} />
              {/* <Route path="analytics" element={
                <div className="p-6">
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                      Analytics Page
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400">
                      Advanced analytics coming soon...
                    </p>
                  </div>
                </div>
              } />
              <Route path="settings" element={
                <div className="p-6">
                  <div className="text-center py-12">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                      Settings Page
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400">
                      Settings panel coming soon...
                    </p>
                  </div>
                </div>
              } /> */}
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;